import { Block, cloneBlock, Blocks } from 'factories/block';
import { createBlock } from './block';
import { flatten } from 'factories/utils';
import { createEditableBtn } from './interactions/editableBtn';

export const createModuleHasAudioMessage = (): Block => {
  return createBlock(
    'ModuleHasAudioMessage',
    [
      createBlock('Image', [], { props: {} }),
      createBlock('Text'),
      createEditableBtn({
        label: 'Ok',
      }),
    ],
    {
      props: {},
    }
  );
};

export const addModuleHasAudioMessageBlock = (
  block: Block,
  props = {}
): [Block, Blocks?] => {
  if (block.type === 'Module') {
    const moduleHasAudioMessageBlock = createModuleHasAudioMessage();

    const moduleHasAudioMessageBlockRef = {
      id: moduleHasAudioMessageBlock.id,
      type: 'Ref',
    };

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).push(moduleHasAudioMessageBlockRef);

    const [newBlocks] = flatten(moduleHasAudioMessageBlock);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};
